import React, { useState } from 'react';
import { StartScreen } from './components/StartScreen';
import { GameBoard } from './components/GameBoard';
import { GameOver } from './components/GameOver';
type GameState = 'start' | 'playing' | 'gameover';
const MAX_LEVELS = 10;
export function App() {
  const [gameState, setGameState] = useState<GameState>('start');
  const [level, setLevel] = useState(1);
  const [totalTime, setTotalTime] = useState(0);
  const startGame = () => {
    setLevel(1);
    setTotalTime(0);
    setGameState('playing');
  };
  const handleLevelComplete = (timeTaken: number) => {
    const newTotalTime = totalTime + timeTaken;
    if (level >= MAX_LEVELS) {
      setTotalTime(newTotalTime);
      setGameState('gameover');
    } else {
      setTotalTime(newTotalTime);
      setLevel(prev => prev + 1);
    }
  };
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-yellow-500/30" data-id="element-0">
      {gameState === 'start' && <StartScreen onStart={startGame} data-id="element-1" />}

      {gameState === 'playing' && <GameBoard level={level} onLevelComplete={handleLevelComplete} data-id="element-2" />}

      {gameState === 'gameover' && <GameOver score={level} totalTime={totalTime} onRestart={startGame} data-id="element-3" />}
    </div>;
}